import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LightingProductCard from '../components/LightingProductCard';

const LightingsGallery = () => {
  const [lightingsData, setLightingsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_BACKEND_URL || '';

  // Fetch products from API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/products/lightings`);
        if (response.ok) {
          const data = await response.json();
          setLightingsData(data);
        }
      } catch (error) {
        console.error('Failed to fetch lightings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [apiUrl]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black pt-24 pb-16 flex items-center justify-center">
        <div className="text-[hsl(45,100%,70%)] text-2xl">Loading lightings...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button - Aligned with logo position */}
        <div className="mb-8 flex justify-center relative z-[60]">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-[hsl(45,100%,70%)] transition-colors group"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Back to home
          </Link>
        </div>

        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
            Chicken Cage <span className="text-[hsl(45,100%,70%)]">Lightings</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Illuminated elegance by our Chicken Cage designs. Each piece is hand-crafted 
            to bring sophisticated lighting and artistic beauty to your space.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {lightingsData.map((product) => (
            <LightingProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* Info Section */}
        <div className="mt-20 bg-gradient-to-r from-[hsl(45,100%,70%)]/10 to-transparent rounded-2xl p-8 md:p-12">
          <h2 className="text-3xl font-bold text-white mb-4">
            Handcrafted Excellence
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed max-w-4xl">
            Each Chicken Cage Lighting is meticulously hand-crafted by our skilled artisans. 
            From intricate lattice patterns to contemporary geometric designs, every piece 
            represents hours of dedicated craftsmanship. Our lightings are not just functional 
            fixtures – they are sculptural art pieces that transform your living spaces into 
            galleries of light and shadow.
          </p>
        </div>
      </div>

      {/* Call-to-Action Section - Lighting Configurator - TEMPORARILY DISABLED */}
      {/* <div className="mt-24 text-center">
        <div className="bg-gradient-to-r from-[hsl(45,100%,70%)]/10 to-transparent rounded-2xl p-12 border border-[hsl(45,100%,70%)]/20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Inspired by our Chicken Cage Lightings?
          </h2>
          <p className="text-gray-700 text-lg mb-8 max-w-2xl mx-auto">
            Create your own custom lighting design with our interactive configurator. 
            Choose colors, patterns, and styles to match your unique vision.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/configurator.html"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-5 bg-[hsl(45,100%,70%)] text-black font-bold text-lg rounded-full hover:shadow-[0_0_30px_rgba(255,215,0,0.5)] transition-all duration-300 hover:scale-105"
            >
              Try Lighting Configurator
            </a>
            <a
              href="/contact"
              className="px-10 py-5 border-2 border-[hsl(45,100%,70%)] text-[hsl(45,100%,70%)] font-bold text-lg rounded-full hover:bg-[hsl(45,100%,70%)] hover:text-black transition-all duration-300 hover:scale-105"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default LightingsGallery;
